
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"54","height":"54","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1091_2833)"}},[_c('rect',{attrs:{"x":"8","y":"4","width":"38","height":"38","rx":"19","fill":"#8DC540"}}),_c('path',{attrs:{"d":"M19.473 32c-.793 0-1.246-.337-1.36-.9-.34-.9.567-1.463.907-1.688.68-.45 1.02-.787 1.133-1.124 0-.226-.113-.45-.34-.788 0 0 0-.113-.113-.113-1.133-1.462-1.7-3.262-1.7-5.062C18 17.712 21.853 14 26.5 14s8.5 3.712 8.5 8.325c0 4.613-3.853 8.325-8.5 8.325-.567 0-1.133-.112-1.7-.225C21.853 31.887 19.7 32 19.7 32h-.227zm2.267-5.738c.567.788.793 1.688.68 2.476 0 .112-.113.337-.113.45.566-.226 1.133-.45 1.813-.788.227-.112.453-.225.68-.112h.113c.454.112 1.02.224 1.587.224 3.4 0 6.233-2.7 6.233-6.075S29.9 16.25 26.5 16.25c-3.4 0-6.233 2.7-6.233 6.075 0 1.35.453 2.7 1.36 3.713 0 .112.113.112.113.224z","fill":"#fff"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1091_2833","x":"0","y":"0","width":"54","height":"54","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"4"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"4"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1091_2833"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1091_2833","result":"shape"}})])])])
          )
        }
      }
    